<template>
  <div class="left-pannel">
    <UserInfo />

    <div class="tool-btns">
      <div class="btn">
        <SearchSvg />
        <span>搜索</span>
      </div>
      <Settings />
    </div>

    <div class="new-btn">
      <el-button type="success" round plain style="width: 100%;" @click="handleNewDoc">新建文档</el-button>
    </div>

    <DocTree ref="doctree"/>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserInfo from './userInfo.vue'
import variables from '@/styles/variables.scss'
import SearchSvg from '@/assets/svg/search.svg'
import DocTree from './docTree.vue'
import Settings from './settings.vue'

export default {
  components: { UserInfo, SearchSvg, DocTree, Settings },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    handleNewDoc() {
      this.$refs.doctree.addTopLevel()
    }
  }
}
</script>
<style lang="scss" scoped>
.left-pannel {
  width: 15rem;
  background-color: #FAFBFC;
  padding: 1.13rem;

  .tool-btns {
    margin-top: 0.63rem;

    button {
      display: block;
      color: #333;
    }
  }

  .new-button {
    margin-top: 1.2rem;
  }

  .tool-btns {
    margin-top: 1.69rem;
  }

  .btn {
    display: flex;
    align-items: center;
    margin-bottom: 1.13rem;

    span {
      padding-left: 0.4rem;
      font-size: 0.88rem;
    }
  }

  .new-btn {
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
  }
}

:deep .el-tree {
  background: none;
}
</style>
